import React, { useState } from "react";

export default function Quiz() {
  const [step, setStep] = useState(1);
  const [connection, setConnection] = useState("");
  const [features, setFeatures] = useState<string[]>([]);
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleFeatureChange = (feature: string) => {
    setFeatures((prev) =>
      prev.includes(feature) ? prev.filter((f) => f !== feature) : [...prev, feature]
    );
  };

  const getRecommendedPlan = () => {
    if (features.includes("Solar Panels")) return "Solar Home Plan";
    if (features.includes("Electric Car") || features.includes("Electric bike/scooter")) return "EV Home Plan";
    if (features.includes("Air conditioner")) return "Flex Cooling Plan";
    if (features.includes("None of the above- but I still want to be a part of the revolution!")) return "General Home Plan";
    return "General Interest Plan";
  };

  const handleSubmit = () => {
    setSubmitted(true);
    // Optional: send data to backend/email service here
  };

  return (
    <div className="max-w-xl mx-auto p-6">
      <div className="mb-4">
        <div className="h-2 bg-gray-200 rounded-full">
          <div
            className="h-full bg-blue-500 rounded-full transition-all duration-300"
            style={{ width: `${(step / 4) * 100}%` }}
          ></div>
        </div>
      </div>

      {!submitted ? (
        <div className="space-y-6">
          {step === 1 && (
            <div>
              <h2 className="text-xl font-semibold mb-2">1. What is your electricity connection?</h2>
              {["Single-phase", "Three-phase", "Not sure"].map((opt) => (
                <div key={opt} className="mb-2">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      name="connection"
                      value={opt}
                      checked={connection === opt}
                      onChange={() => setConnection(opt)}
                      className="mr-2"
                    />
                    {opt}
                  </label>
                </div>
              ))}
              <button
                disabled={!connection}
                onClick={() => setStep(2)}
                className="mt-4 bg-blue-600 text-white py-2 px-4 rounded"
              >
                Next
              </button>
            </div>
          )}

          {step === 2 && (
            <div>
              <h2 className="text-xl font-semibold mb-2">2. Which of the following do you have at home?</h2>
              {["Solar Panels", "Electric Car", "Electric bike/scooter", "Air conditioner", "None of the above- but I still want to be a part of the revolution!"].map((feature) => (
                <div key={feature} className="mb-2">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      value={feature}
                      checked={features.includes(feature)}
                      onChange={() => handleFeatureChange(feature)}
                      className="mr-2"
                    />
                    {feature}
                  </label>
                </div>
              ))}
              <button
                onClick={() => setStep(3)}
                className="mt-4 bg-blue-600 text-white py-2 px-4 rounded"
              >
                Next
              </button>
            </div>
          )}

          {step === 3 && (
            <div>
              <h2 className="text-xl font-semibold mb-2">Almost there! Where can we send your recommended plan?</h2>
              <input
                type="email"
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
              />
              <button
                disabled={!email}
                onClick={() => {
                  handleSubmit();
                  setStep(4);
                }}
                className="bg-green-600 text-white py-2 px-4 rounded"
              >
                See My Plan
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-4">Thank you for your response!</h2>
          <p className="mb-2">
            Based on your setup, we recommend the <strong>{getRecommendedPlan()}</strong>.
          </p>
          <p>The details of your recommended plan will be emailed to you shortly.</p>
        </div>
      )}
    </div>
  );
}
